module.exports = __webpack_public_path__ + "img/journey-icon.03dfa15d.svg";